import { Category, type CloudProviderName, type CloudProviderTag, InsightPriority } from "./types";

export const ALL_CLOUD_PROVIDERS: CloudProviderTag[] = ["aws", "gcp", "azure", "snowflake"];

export const CLOUD_PROVIDERS_TITLES_MAP: Record<CloudProviderTag, CloudProviderName> = {
  aws: "Amazon Web Services",
  gcp: "Google Cloud",
  azure: "Azure",
  snowflake: "Snowflake",
};

export const ALL_CATEGORIES: Category[] = Object.values(Category);

type PriorityList = { label: string; value: InsightPriority }[];

export const PRIORITY_LIST: PriorityList = [
  { label: "High", value: InsightPriority.High },
  { label: "Medium", value: InsightPriority.Medium },
  { label: "Low", value: InsightPriority.Low },
];

export const savingsPeriodToLabel = {
  daily: "day",
  monthly: "month",
  yearly: "year",
};
